import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import Logo from '../../assets/app/logo.png'
import { FiHome, FiCalendar, FiBookOpen, FiMessageSquare, FiSliders, FiMenu, FiX, FiBell, FiSettings } from 'react-icons/fi';
import { MenuItem } from './menuItem';
import { createStudent, switchToStudentProfile } from '../../store/profile/profileActions';
import { FaMoneyBillTransfer, FaMoneyCheck, FaQuestion } from 'react-icons/fa6';
import { goToSupport, fetchChatUnreadCount } from '../../store/chat/chatActions';
import { fetchInAppUnreadCount } from '../../store/notification/notificationActions';
import { ProfileRole, ProfileStatusEnum } from '../../store/profile/profileSlice';
import { COURSES_URL } from '../app/routes';

const NavbarTutor = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const { appointments, wallet, inAppUnreadCount } = useSelector(state => state.notification)
	const unreadCount = useSelector((state) => state.chat.unreadCount);
	const { currentProfile } = useSelector((state) => state.profile);

	useEffect(() => {
		if (!currentProfile?._id) return;
		dispatch(fetchChatUnreadCount());
		dispatch(fetchInAppUnreadCount());
	}, [currentProfile?._id, dispatch]);

	const [menuOpen, setMenuOpen] = useState(false);
	const profileList = useSelector((state) => state.auth.profileList);
	const studentProfile = profileList.find(v => v.role === ProfileRole.STUDENT);
	
	const switchToStudent = () => {
		dispatch(switchToStudentProfile())
			.then(() => navigate("/"))
	}

	const createStudentProfile = () => {
		dispatch(createStudent())
			.unwrap()
			.then(() => {
				navigate("/", { replace: true })
			})
	}

	const SwitchProfile = () => {
		if (studentProfile && studentProfile.status === ProfileStatusEnum.active)
			return <div onClick={() => switchToStudent()} className='inline-table mx-auto self-end left-[25px] bg-nt-blue w-[90%] mb-5 text-sm text-white py-2 px-5 rounded cursor-pointer'>
				Switch to Student
			</div>
		else if (!studentProfile)
			return <div onClick={() => createStudentProfile()} className='inline-table mx-auto self-end left-[25px] bg-nt-blue w-[90%] mb-5 text-sm text-white py-2 px-5 rounded cursor-pointer'>
			Become a student
		</div>
	}

	const Support = () => {
		return <div title="Support" className='fixed top-2 xl:top-6 shadow-xl hover:bg-nt-blue hover:text-white right-2 xl:right-4 flex items-center justify-center rounded-full z-50 bg-white w-10 h-10 cursor-pointer' 
		onClick={() => handleSupport()}>
			<FaQuestion  size={20} /></div>
	}
	
	const handleSupport = () => {
			dispatch(goToSupport())
			.unwrap()
			.then((v) => navigate("/chat/" + v._id))
		
	}

	// Menu lock for incomplete lastStep disabled — lastStep is completed in the tutor wizard
	const isTutorMenuLocked = false;
	// const isTutorMenuLocked =
	// 	currentProfile?.role === ProfileRole.TUTOR &&
	// 	currentProfile?.status === ProfileStatusEnum.active &&
	// 	!currentProfile?.lastStep;

	return (
		<>
			<div className='fixed xl:hidden bg-white w-full flex z-98 justify-center items-center py-2'>
				<div className='xl:hidden'>
					<button onClick={() => setMenuOpen((old) => !old)} className='absolute left-2 top-2 p-2 rounded-full bg-nt-blue text-white grid place-items-center shadow-md'>
						{!menuOpen ? <FiMenu size={24} /> : <FiX size={24} />}
					</button>
				</div>
				<img src={Logo} className='self-center justify-self-center max-h-[40px]' /> 
				<Support />
			</div>
			<div className={`overflow-y-auto h-[calc(100%-3.5rem)] xl:min-h-screen rounded-tr-3xl rounded-br-3xl flex flex-col bg-white 
				z-50 fixed transition-all duration-300 top-14 xl:top-0
				${menuOpen ? "translate-x-0 w-[300px] items-start p-6" : "-translate-x-full md:translate-x-0 w-[300px] md:w-16 items-start md:items-center p-6 md:p-2"}
				xl:translate-x-0 xl:w-[300px] xl:items-start xl:p-6`}>
				<img src={Logo} className='hidden xl:block mb-5 max-w-[120px]' />
				<span className='hidden xl:block'><Support /></span>
				<div className={'w-full flex-1 mb-4'}>
					<ul className={`space-y-3 ${isTutorMenuLocked ? "pointer-events-none select-none opacity-60" : ''}`}>
						<li className='w-full select-none text-nt-blue hover:bg-nt-red hover:text-white group rounded'>
							<MenuItem collapsed={!menuOpen} menuOpen={() => setMenuOpen(false)} title="Dashboard" Icon={FiHome} link='/' />
						</li>
						<li className='w-full select-none text-nt-blue hover:bg-nt-red hover:text-white group rounded'>
							<MenuItem collapsed={!menuOpen} menuOpen={() => setMenuOpen(false)} title="Courses" Icon={FiBookOpen} link={COURSES_URL} notification={appointments} />
						</li>
						<li className='w-full select-none text-nt-blue hover:bg-nt-red hover:text-white group rounded'>
							<MenuItem collapsed={!menuOpen} menuOpen={() => setMenuOpen(false)} title="Calendar" Icon={FiCalendar} link='/calendar' />
						</li>
						<li className='w-full select-none text-nt-blue hover:bg-nt-red hover:text-white group rounded'>
							<MenuItem collapsed={!menuOpen} menuOpen={() => setMenuOpen(false)} title="Chat" Icon={FiMessageSquare} link='/chat' notification={unreadCount} />
						</li>
						<li className='w-full select-none text-nt-blue hover:bg-nt-red hover:text-white group rounded'>
							<MenuItem collapsed={!menuOpen} menuOpen={() => setMenuOpen(false)} title="Transactions" Icon={FaMoneyBillTransfer} link='/wallet' notification={wallet} />
						</li>
						<li className='w-full select-none text-nt-blue hover:bg-nt-red hover:text-white group rounded'>
							<MenuItem collapsed={!menuOpen} menuOpen={() => setMenuOpen(false)} title="Withdraw" Icon={FaMoneyCheck} link='/withdraw' />
						</li>
						<li className='w-full select-none text-nt-blue hover:bg-nt-red hover:text-white group rounded'>
							<MenuItem collapsed={!menuOpen} menuOpen={() => setMenuOpen(false)} title="Notifications" Icon={FiBell} link='/notifications' notification={inAppUnreadCount} />
						</li>
						<li className='w-full select-none text-nt-blue hover:bg-nt-red hover:text-white group rounded'>
							<MenuItem collapsed={!menuOpen} menuOpen={() => setMenuOpen(false)} title="Settings" Icon={FiSettings} link='/settings' />
						</li>
					</ul>
				</div>

				<span className={!menuOpen ? 'hidden md:hidden xl:block w-full' : 'w-full'}>
					<SwitchProfile />
				</span>
			</div>
		</>
	);
};

export { NavbarTutor };
